import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function getGroupPlayers(league_pk, team_pk) {
  const token = Cookies.getToken();

  const res = await axios({
    method: 'GET',
    url:
      process.env.REACT_APP_API_URL +
      `/api/league/leagues/${league_pk}/teams/${team_pk}/players/`,
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 200) {
    return res.data;
  } else {
    return { error: res.status };
  }
}

